import { useLayout } from 'context'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import * as controllers from 'controllers'
import { ArrowBack } from '@mui/icons-material'
import { Grid, Card, CardContent, Typography, Button } from '@mui/material'
import { VehicleWaitingOnThirdPartyAdditionalProgrammingDetailsDto } from 'dtos'
import { enqueueSnackbar } from 'notistack'
import VehicleWaitingOnThirdPartyAdditionalProgrammingHeroCard from './VehicleWaitingOnThirdPartyAdditionalProgrammingHeroCard'
import Step1AdditionalProgrammingCompleted from './Step1AdditionalProgrammingCompleted'

export default function WaitingOnThirdPartyAdditionalProgramming() {
  const { vehicleGuid } = useParams()
  const layout = useLayout()
  const navigate = useNavigate()

  const [initialValues, setInitialValues] = useState<VehicleWaitingOnThirdPartyAdditionalProgrammingDetailsDto>(
    new VehicleWaitingOnThirdPartyAdditionalProgrammingDetailsDto()
  )

  const [activeStep] = useState<number>(0)

  useEffect(() => {
    if (vehicleGuid) {
      layout.setIsLayoutLoading(true)
      controllers
        .getWaitingOnThirdPartyAdditionalProgrammingDetails(vehicleGuid)
        .then(response => {
          setInitialValues(response.value)
        })
        .finally(() => {
          layout.setIsLayoutLoading(false)
        })
    }
  }, [vehicleGuid])

  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid container justifyContent='space-between'>
              <Grid item>
                <Typography fontWeight='bold' variant='h5' sx={{ pr: 1 }}>
                  Waiting On 3rd Party Additional Programming
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto' container spacing={2} alignItems='center' justifyContent='flex-end'>
                <Grid item>
                  <Button
                    onClick={() => {
                      navigate('/to-do-list')
                    }}
                    color='primary'
                    startIcon={<ArrowBack />}
                    variant='text'
                  >
                    BACK
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <VehicleWaitingOnThirdPartyAdditionalProgrammingHeroCard vehicle={initialValues} />
      </Grid>

      {activeStep === 0 && (
        <Grid item xs={12}>
          <Step1AdditionalProgrammingCompleted
            waitingOnThirdPartyAdditionalProgramming={initialValues}
            onNext={() => {
              layout.setIsLayoutLoading(true)
              controllers
                .updateWaitingOnThirdPartyAdditionalProgrammingDetails(vehicleGuid!, {
                  ...initialValues
                })
                .then(response => {
                  enqueueSnackbar('Third Party Additional Programming Completed', { variant: 'success' })
                  setInitialValues(response.value)
                  navigate('/to-do-list', { replace: true })
                })
                .finally(() => {
                  layout.setIsLayoutLoading(false)
                })
            }}
            vehicle={initialValues}
            vehicleGuid={vehicleGuid}
          />
        </Grid>
      )}
    </Grid>
  )
}
